export default "__VITE_ASSET__CoD3Dma4__"